module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-desktop-phone.en-ec2bed3045f1df2415cce9bab584979f.png";